document.addEventListener("DOMContentLoaded", async function () {
  const getHighestPriceByBreakQty = (breakPoints = [], breakQty = 1) => {
      const validPrices = breakPoints?.filter((p) => p.breakQty <= breakQty);
      if (validPrices.length === 0) return null;

      return validPrices.reduce((max, p) => (p.price > max.price ? p : max));
  };

  const validPaths = ["/", "/cart"];
  if (!validPaths.includes(window.location.pathname)) return;

  try {
      let cart = await fetch(window.routes.cart_url + ".js").then((res) =>
          res.json()
      );

      const {
          companyId = null,
          locationId = null,
          customerId = null,
          customPricingUrl = null,
          shopId = null,
      } = window.globalData || {};

      if (!locationId || !customerId || !customPricingUrl) return;

      const skus = cart.items.map((item) => item.sku).join(",");

      const apiUrl = `${customPricingUrl}/shop/${shopId}/customPricing?skus=${encodeURIComponent(
          skus
      )}&locationId=${locationId}&companyId=${companyId}&customerId=${customerId}`;
      const response = await fetch(apiUrl);

      let itemDataMap = new Map();
      if (response.ok) {
          const data = await response.json();
          itemDataMap = new Map(
            data.map((item) => [
              item.sku,
              {
                _prices: item.prices ? JSON.stringify([getHighestPriceByBreakQty(item.prices)]) : null,
                _locations: item.locations ? JSON.stringify(item.locations) : null,
                _currentLocationId: locationId,
              },
            ])
          );
      } 

      //checks for changing locations
      for (const item of cart.items) {
        const itemProps = item.properties || {};
        const itemLocationId = itemProps._currentLocationId;
      
        const data = itemDataMap.get(item.sku);
        if (!data) continue;
      
        if (itemLocationId !== locationId) {
          await fetch(window.routes.cart_change_url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties: data,
            }),
          });
        }
      }

      //checks if no pricing properties
      let shouldRefresh = false;
      for (const item of cart.items) {
        const itemProps = item.properties || {};
        const itemLocationId = !!itemProps._currentLocationId;
        const hasPrices = !!itemProps._prices;
        const hasLocations = !!itemProps._locations;
      
        const data = itemDataMap.get(item.sku);
        if (!data) continue;
      
        if (!itemLocationId || !hasPrices || !hasLocations) {
          shouldRefresh = true;
          await fetch(window.routes.cart_change_url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties: data,
            }),
          });
        }
      }

      if (window.location.pathname === "/cart" && shouldRefresh) {
        window.location.reload();
      }

      console.log("Cart update completed!");
  } catch (error) {
      console.error("Cart update error:", error);
  }
});
